<template>
  <div class="column-edit-size">
    <el-input v-model.number="overLeft" type="number" size="mini" data-index="overLeft" @input="handleChange" />
    <span>-</span>
    <el-input v-model.number="overRight" type="number" size="mini" data-index="overRight" @input="handleChange" />
    <span>-</span>
    <el-input v-model.number="overFront" type="number" size="mini" data-index="overFront" @input="handleChange" />
    <span>-</span>
    <el-input v-model.number="overBack" type="number" size="mini" data-index="overBack" @input="handleChange" />
    <span>-</span>
    <el-input v-model.number="overHeight" type="number" size="mini" data-index="overHeight" @input="handleChange" />
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'CargoAgGridColumnEditGroupFive',
  data() {
    return {
      custom: null,
      valueChanged: null,
      overLeft: 0,
      overRight: 0,
      overFront: 0,
      overBack: 0,
      overHeight: 0
    }
  },
  created() {
    this.custom = this.params
    this.overLeft = parseInt(this.custom.data.overLeft)
    this.overRight = parseInt(this.custom.data.overRight)
    this.overFront = parseInt(this.custom.data.overFront)
    this.overBack = parseInt(this.custom.data.overBack)
    this.overHeight = parseInt(this.custom.data.overHeight)
    this.valueChanged = this.custom.valueChanged
  },
  methods: {
    handleChange() {
      this.custom.data.overLeft = parseInt(this.overLeft)
      this.custom.data.overRight = parseInt(this.overRight)
      this.custom.data.overFront = parseInt(this.overFront)
      this.custom.data.overBack = parseInt(this.overBack)
      this.custom.data.overHeight = parseInt(this.overHeight)
      this.valueChanged(this.custom)
    }
  }
})
</script>

<style lang="scss" scoped>
.column-edit-size{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 2px 10px;
  .el-input{
    height: 24px;
    line-height: 24px;
    /deep/ .el-input__inner{
      height: 24px;
      text-align: right;
    }
  }
  span{
    height: 24px;
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
